import { render } from "./MagicLinksComponent.vue?vue&type=template&id=7639f63d&scoped=true&ts=true"
import script from "./MagicLinksComponent.vue?vue&type=script&lang=ts"
export * from "./MagicLinksComponent.vue?vue&type=script&lang=ts"

import "./MagicLinksComponent.vue?vue&type=style&index=0&id=7639f63d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7639f63d"]])

export default __exports__